// Angular imports
import { Injectable, EventEmitter } from '@angular/core';

// Import observable
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SideMenuService {
    // Observables for events
    public get _requestOpen(): Observable<void> { return this._requestOpenEmitter; }
    public get _requestClose(): Observable<void> { return this._requestCloseEmitter; }
    
    // Publically readonly
    public get isOpen(): boolean { return this._isOpen; }

    // Event emitters
    private _requestOpenEmitter = new EventEmitter<void>();
    private _requestCloseEmitter = new EventEmitter<void>();

    private _isOpen: boolean = true;

    constructor() { }

    /**
     * Opens the side menu.
     */
    public open() {
        if (this._isOpen) throw new Error('Attempted to open the side menu while it is already open.');

        // Emit request open event
        this._requestOpenEmitter.emit();

        // Set open
        this._isOpen = true;
    }

    /**
     * Closes the side menu.
     */
    public close() {
        // if (!this._isOpen) throw new Error('Attempted to close the side menu while it is already closed.');

        // Emit requets close event
        this._requestCloseEmitter.emit();

        // Set closed
        this._isOpen = false;
    }
}
